import React from "react";
import {useTranslation} from "react-i18next";
import {SelectField} from "./FilterComponentStyles";
import {ObjectionStatusFilterPropTypes} from "./FilterComponentPropTypes";
import {useObserver} from "mobx-react-lite";
import {arrayAlphabeticalSort} from "../../../utils/helpers";
import {objectionStatuses} from "../../../constants/constants";
const ObjectionStatusFilter = ({
    allKey = "all",
    showAll = true,
    hideTitle = false,
    ...props
}: ObjectionStatusFilterPropTypes) => {
    const {t} = useTranslation(["objectionStatuses"]);

    return useObserver(() => (
        <React.Fragment>
            {!hideTitle && <h5>{t("fields.status", {ns: "common"})}</h5>}
            <SelectField
                allowClear
                showSearch
                filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                data-testid="objectionStatusSelect"
                {...props}
            >
                {showAll && (
                    <SelectField.Option value={allKey} data-testid="objectionStatusSelect_option">
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                )}

                {arrayAlphabeticalSort([...objectionStatuses], "value").map(objectionStatus => (
                    <SelectField.Option
                        key={objectionStatus.value}
                        value={objectionStatus.value}
                        data-testid="objectionStatusSelect_option"
                    >
                        {t(objectionStatus.translation_key, {ns: "objectionStatuses"})}
                    </SelectField.Option>
                ))}
            </SelectField>
        </React.Fragment>
    ));
};

export default ObjectionStatusFilter;
